module.exports = __webpack_public_path__ + "static/img/3.a194901.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/recordInformation/3.png
// module id = 300
// module chunks = 2